<template>
  <div>
    <title>申请开票</title>
    <section class="mainDet">
      <div class="invoiceBox">
        <div class="commonTit flexUI">
          <b>申请开票</b>
          <dl class="flexUI" v-if="bindMemberInfo">
            <dt>会员信息：</dt>
            <dd>
              <span class="textFl name150" :title="bindMemberInfo.nickname">{{bindMemberInfo.nickname}}</span>
              {{bindMemberInfo.mphone}}
            </dd>
            <dd>剩余开票金额：<span>￥{{(bindMemberInfo.caninvoiceprice - alreadyInvoiceMoney) | formatAmount}}</span></dd>
            <dd>已申请，待开票金额：<span>￥{{bindMemberInfo.toinvoiceprice | formatAmount}}</span></dd>
            <dd>已开票金额：<span>￥{{bindMemberInfo.hasinvoiceprice | formatAmount}}</span></dd>
            <dd class="blueColor cursorHand" @click="updateMember" v-if="!recordCode">修改&nbsp;&gt;</dd>
          </dl>
        </div>
        <!--S 选择买卖双方-->
        <section class="tradingRoleBox flexUI">
          <div class="tradeWrap" :class="{'selval':buyerInfo!==''}">
            <el-button v-if="buyerInfo==''|| buyerInfo==null" type="primary" @click="selTradeRole(0)">选择购买方</el-button>
            <div v-else class="bannerBg">
              <p class="bannerTit">
                <b>购买方</b>
                <el-tag v-if="buyerInfo.invoicetype==1" type="warning" plain title="增值税发票">增值税发票</el-tag>
                <el-tag v-else plain :title="`普通发票/${buyerInfo.commontype==0?'个人':'公司'}`">普通发票/{{buyerInfo.commontype==0?'个人':'公司'}}</el-tag>
                <em class="blueColor" @click="selTradeRole(0,'edit')">修改&nbsp;&gt;</em>
              </p>
              <ul class="basicWrap">
                <li class="rulrMemo">
                  <em>{{buyerInfo.invoicetype!=1 && buyerInfo.commontype==0?'抬头名称：':'公司名称：'}}</em>
                  <b>{{buyerInfo.name}}</b>
                </li>
                <li v-if="buyerInfo.invoicetype==1 || (buyerInfo.invoicetype!=1&&buyerInfo.commontype!=0)">
                  <em>公司税号：</em>
                  <b>{{buyerInfo.invoicetaxno}}</b>
                </li>
                <li class="rulrMemo" v-if="buyerInfo.invoicetype==1 || (buyerInfo.invoicetype!=1&&buyerInfo.commontype!=0&&(buyerInfo.addr || buyerInfo.tel))">
                  <em>地址、电话：</em>
                  <b v-if="buyerInfo.addr">{{buyerInfo.addr}}&nbsp;&nbsp;{{buyerInfo.tel}}</b>
                  <b v-else>{{buyerInfo.tel}}</b>
                </li>
                <li class="rulrMemo" v-if="buyerInfo.invoicetype==1 || (buyerInfo.invoicetype!=1&&buyerInfo.commontype!=0&&(buyerInfo.depositbank || buyerInfo.bankaccount))">
                  <em>开户行及账号：</em>
                  <b v-if="buyerInfo.depositbank">{{buyerInfo.depositbank}}&nbsp;&nbsp;{{buyerInfo.bankaccount}}</b>
                  <b v-else>{{buyerInfo.bankaccount}}</b>
                </li>
              </ul>
            </div>
          </div>
          <div class="tradeWrap" :class="{'selval':sellerInfo!==''}">
            <el-button v-if="sellerInfo==''|| sellerInfo==null" type="primary" @click="selTradeRole(1)">选择销售方</el-button>
            <div v-else class="bannerBg">
              <p class="bannerTit">
                <b>销售方</b>
                <em class="blueColor" @click="selTradeRole(1,'edit')">修改&nbsp;&gt;</em>
              </p>
              <ul class="basicWrap">
                <li class="rulrMemo">
                  <em>公司名称：</em>
                  <b>{{sellerInfo.name}}</b>
                </li>
                <li>
                  <em>公司税号：</em>
                  <b>{{sellerInfo.invoicetaxno}}</b>
                </li>
                <li class="rulrMemo">
                  <em>地址、电话：</em>
                  <b>{{sellerInfo.addr}}&nbsp;&nbsp;{{sellerInfo.tel}}</b>
                </li>
                <li class="rulrMemo">
                  <em>开户行及账号：</em>
                  <b>{{sellerInfo.depositbank}}&nbsp;&nbsp;{{sellerInfo.bankaccount}}</b>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <!--E 选择买卖双方-->
        <el-form :model="applelyInvoiceForm" label-width="120px" class="comForm" ref="applelyForm" :rules="applelyRules">
          <el-form-item label="明细分类">
            <p class="radioGroup">
              <span :class="applelyInvoiceForm.type==0?'iconradio':'iconselect'" @click="packTypeChange(0)" >单品</span>
              <span :class="applelyInvoiceForm.type==1?'iconradio':'iconselect'" @click="packTypeChange(1)">打包产品</span>
            </p>
            <!-- <el-radio-group v-model="applelyInvoiceForm.type">
              <el-radio :label="0">单品</el-radio>
              <el-radio :label="1">打包产品</el-radio>
            </el-radio-group> -->
          </el-form-item>
          <el-form-item label="发票介质">
            <el-radio-group v-model="applelyInvoiceForm.invmedium">
              <el-radio :label="0">纸质发票</el-radio>
              <el-radio :label="1">电子发票</el-radio>
            </el-radio-group>
          </el-form-item> 
          <el-form-item label="电子邮箱" v-if="applelyInvoiceForm.invmedium == 1">
            <el-input v-model="applelyInvoiceForm.email" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="开票申请说明" prop="applymeno">
            <el-input type="textarea" v-model="applelyInvoiceForm.applymeno" maxlength="50" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <p class="btnLine">
          <span v-show="applelyInvoiceForm.type == 0 && applelyInvoiceForm.pkggoodsData.length>0" class="redColor" @click="emptyInvGoods()">清空</span>
          <i v-show="applelyInvoiceForm.type == 0 && applelyInvoiceForm.pkggoodsData.length>0">|</i>
          <span class="blueColor" @click="openCreateInvoice(0)">{{applelyInvoiceForm.pkggoodsData.length>0?(applelyInvoiceForm.type == 0?'修改发票内容':'追加发票内容'):'创建发票内容'}}</span>
        </p>
        <!--S 发票内容项-->
        <el-table :data="applelyInvoiceForm.pkggoodsData" border class="comTable" maxHeight="350">
          <el-table-column type="index" label="序号" fixed></el-table-column>
          <el-table-column label="产品名称" prop="invgoodsname" sortable fixed min-width="200">
            <template slot-scope="scope">
              <p class="textFl pdr50" :title="scope.row.invgoodsname">{{scope.row.invgoodsname}}</p>
            </template>
          </el-table-column>
          <el-table-column label="规格型号" prop="invkindinfo" sortable min-width="200">
            <template slot-scope="scope">
              <p class="textFl pdr50" :title="scope.row.invkindinfo">{{scope.row.invkindinfo}}</p>
            </template>
          </el-table-column>
          <el-table-column label="单位" prop="unit" sortable min-width="120">
            <template slot-scope="scope">
              <span>{{scope.row.unit}}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="num" sortable min-width="120">
            <template slot-scope="scope">
              <span>{{scope.row.num}}</span>
            </template>
          </el-table-column>
          <el-table-column label="单价(￥)" prop="unitprice" sortable min-width="180">
            <template slot-scope="scope">
              <span>{{scope.row.unitprice}}</span>
            </template>
          </el-table-column>
          <el-table-column label="金额(￥)" prop="amount" sortable min-width="180">
            <template slot-scope="scope">
              <span>{{scope.row.amount | formatAmount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="税率(%)" prop="taxrate" sortable min-width="150">
            <template slot-scope="scope">
              <span>{{scope.row.taxrate}}</span>
            </template>
          </el-table-column>
          <el-table-column label="税额(￥)" prop="taxamount" sortable min-width="150">
            <template slot-scope="scope">
              <span>{{scope.row.taxamount | formatAmount}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="applelyInvoiceForm.type==1" :key="1" label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <p class="handle">
                <span title="编辑" @click="openCreateInvoice(scope.row.detailcode,scope.$index)"><i class="iconedit"></i></span>
                <span title="删除" @click="deleteRow(scope.$index, applelyInvoiceForm.pkggoodsData,'删除')"><i class="icondel"></i></span>
              </p>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData">
              <!-- <span>暂无数据</span> -->
              <p class="singleGoodsTip">亲，您尚未创建发票内容~，点击&nbsp;&nbsp;<em class="blueColor cursorHand" @click="openCreateInvoice(0)">创建发票内容&gt;</em></p>
            </div>
          </template>
        </el-table>
        <!--E 发票内容项-->
      </div>
      <div class="bottomBtn">
        <span class="ftDgTip">产品价税合计
          <em v-if="applelyInvoiceForm.type == 0">￥{{allTotalMoney | formatAmount}}</em>
          <em v-else>￥{{alreadyInvoiceMoney | formatAmount}}</em>
        </span>
        <el-button type="primary" @click="toSubmit">提交</el-button>
        <el-button @click="$router.back(-1)">返回列表</el-button>
      </div>
    </section>


    <!--S 更改开票会员-->
    <InvoiceMember v-if="invoiceMemberShow" :memberInfo="bindMemberInfo" :selectMemberShow="invoiceMemberShow" :operateType="1" @closeSelinvMember="memberSelected"></InvoiceMember>
    <!--E 更改开票会员-->

    <!--S 选择买卖方弹窗-->
    <BuyerAndSellerPop :buyerOrsellerInfo="buyerOrsellerInfo" :membercode="memberCode" :selTradeRoleShow="selTradeRoleShow" :roleType="roleType" @closeBuyerSeller="closebasPop"></BuyerAndSellerPop>
    <!--S 选择买卖方弹窗-->

    <!--S 创建发票内容弹窗-->
    <el-dialog :visible.sync="createInvoiceItemShow" class="comDlog createInvoiceBox" append-to-body :close-on-click-modal="false">
      <div slot="title" class="dialog-title">
        创建发票内容
        <!-- <span class="redColor iconbulb" v-if="Number(totalMoney) > Number(createForm.totalAmount)">注意：当前选择的开票商品项金额，已超出“本次开票价税金额”，请更改数量或商品</span> -->
      </div>
      <p class="memberLine" v-if="bindMemberInfo">
        <em>会员信息：</em>
        <span class="textFl name150" :title="bindMemberInfo.nickname">{{bindMemberInfo.nickname}}</span>
        <span>{{bindMemberInfo.mphone}}</span>
        <span>剩余开票金额：
          <b class="redColor" v-if="!detailcode">￥{{(bindMemberInfo.caninvoiceprice - alreadyInvoiceMoney) | formatAmount}}</b>
          <b class="redColor" v-else>￥{{(bindMemberInfo.caninvoiceprice - alreadyInvoiceMoney + Number(cacheList[editIndex].totalAmount)) | formatAmount}}</b>
        </span> 
        <span class="greyColor">{{sellerInfo.name}}当前最高可开票金额：
          <b class="blueColor" v-if="!detailcode">￥{{(sysCaninvoiceprice - alreadyInvoiceMoney) | formatAmount}}</b>
          <b class="blueColor" v-else>￥{{(sysCaninvoiceprice - alreadyInvoiceMoney + Number(cacheList[editIndex].totalAmount)) | formatAmount}}</b>
        </span>    
      </p>
      <div class="flexBet" v-if="applelyInvoiceForm.type==0">
        <el-form :model="createForm" inline class="comForm" size="medium" ref="creatForms" :rules="delieveryRules">
          <el-form-item label="本次开票价税金额" class="defineRow" prop="totalAmount"><!--当金额超出可开票金额is-error-->
            <el-input v-model="createForm.totalAmount" placeholder="输入本次需开票价税金额" clearable>
              <template slot="prepend">￥</template>
            </el-input>
            <span class="blueColor btnRight" @click="setAllMoney" v-if="bindMemberInfo">全部开票</span>
          </el-form-item>
          <el-form-item  label="计算方式" label-width="200px" v-if="createForm.haveSelectedData.length>0">
            <el-radio-group v-model="computedWay">
              <el-radio :label="0">自动计算</el-radio>
              <el-radio :label="1">手动计算</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <p>
          <small class="greyColor" v-if="balancePrice>0">（建议从上到下调整数量）</small>
          <span class="orangeColor cursorHand" @click="numReset" v-if="createForm.haveSelectedData.length>0">重置商品数量</span>
          <i v-if="createForm.haveSelectedData.length>0">|</i>
          <span class="blueColor cursorHand" @click="openSelInvoice">{{createForm.haveSelectedData.length>0?'修改开票商品':'选择开票商品'}}&nbsp;&gt;</span>
        </p> 
      </div>
      <div v-else>
        <el-form :model="createForm" label-width="140px" class="comForm" ref="creatForms" size="medium" :rules="delieveryRules">
          <el-row class="goodsWrap">
            <el-col :span="7">
              <el-form-item label="本次开票价税金额" class="defineRow" prop="totalAmount"><!--当金额超出可开票金额is-error-->
                <el-input type="number" v-model="createForm.totalAmount" placeholder="输入本次需开票价税金额" clearable>
                  <template slot="prepend">￥</template>
                </el-input>
                <span class="blueColor btnRight" @click="setAllMoney" v-if="bindMemberInfo">全部开票</span>
              </el-form-item>
              <el-form-item label="产品名称" prop="invgoodsname">
                <el-input v-model="createForm.invgoodsname" placeholder="输入产品名称" clearable maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="规格型号" prop="invkindinfo">
                <el-input v-model="createForm.invkindinfo" placeholder="输入规格型号" clearable maxlength="40"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <!-- <el-form-item label="产品税率"  class="defineRow">
                <el-input-number v-model="createForm.taxrate" :min="1" :max="20" :step="1" step-strictly disabled></el-input-number>
                <em class="btnRight">(%)</em>
              </el-form-item> -->
              <el-form-item label="产品税率">
                <el-input v-model="createForm.taxrate" disabled>
                  <i slot="append">%</i>
                </el-input>
              </el-form-item>
              <el-form-item label="税额总计">
                <el-input v-model="createForm.taxamount" disabled>
                  <template slot="prepend">￥</template>
                </el-input>
              </el-form-item>
              <el-form-item label="单位" prop="unit">
                <el-input v-model="createForm.unit" placeholder="输入单位" clearable maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="产品金额">
                <el-input v-model="createForm.amount" disabled width="100">
                  <template slot="prepend">￥</template>
                </el-input>
              </el-form-item>
              <el-form-item label="产品单价">
                <el-input v-model="createForm.unitprice" disabled width="100">
                  <template slot="prepend">￥</template>
                </el-input>
              </el-form-item>
               <el-form-item label="产品数量">
                <el-input-number v-model="createForm.num" :min="1" :max="99999" :step="1" step-strictly></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="3" class="txtItem">
              <el-form-item class="allWith">
                <span v-if="createForm.toatalMinAmount">({{createForm.toatalMinAmount}}-{{createForm.toatalMaxAmount}})</span>
              </el-form-item>
              <!-- <el-form-item class="allWith">
                <span v-if="createForm.toatalMinPrice">({{createForm.toatalMinPrice}}-{{createForm.toatalMaxPrice}})</span>
              </el-form-item> -->
            </el-col>
          </el-row>
        </el-form>
        <p class="btnLine">
          <small class="greyColor" v-if="balancePrice>0">（建议从上到下调整数量）</small>
          <span class="orangeColor cursorHand" @click="numReset" v-if="createForm.haveSelectedData.length>0">重置商品数量</span>
          <i v-if="createForm.haveSelectedData.length>0">|</i>
          <span class="blueColor cursorHand" @click="openSelInvoice">{{createForm.haveSelectedData.length>0?'更改开票商品':'选择开票商品'}}&nbsp;&gt;</span>
        </p>
      </div>
      <el-table :data="createForm.haveSelectedData" border class="comTable" :height="applelyInvoiceForm.type==0?450:350">
        <el-table-column width="50" type="index" label="序号" fixed></el-table-column>
        <el-table-column label="产品名称" prop="invgoodsname" sortable fixed min-width="180">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.invgoodsname">{{scope.row.invgoodsname}}</p>
          </template>
        </el-table-column>
        <el-table-column label="规格型号" prop="invkindinfo" sortable min-width="150">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.invkindinfo">{{scope.row.invkindinfo}}</p>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="num" sortable min-width="320">
          <template slot-scope="scope">
            <p class="flexUpDownCenter">
              <!-- <el-input class="editIpt" v-model="scope.row.num" clearable size="medium" @input="numChange(scope.row)" @blur="numBlur(scope.row)">
                <template slot="append">{{scope.row.unit}}</template>
              </el-input>
              <span class="pl10">剩余：{{scope.row.availableinv}}</span> -->
              <el-input-number v-model="scope.row.num" class="editIpt" :min="1" :max="countSurplusStock(scope.row)" @change="numChange(scope.row)" size="small" :step="1" step-strictly clearable v-if="scope.row.issuppdecimal!=1"></el-input-number>
              <el-input-number v-model="scope.row.num" class="editIpt" :min="0.1" :max="countSurplusStock(scope.row)" @change="numChange(scope.row)" size="small" :precision="1" :step="0.1" step-strictly clearable v-else></el-input-number>
              <em class="unitTxt" :title="scope.row.unit">{{scope.row.unit}}</em>,
              <span class="pl10 avaiTxt" :title="countSurplusStock(scope.row)">剩余：{{countSurplusStock(scope.row)}}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="单价(￥)" prop="unitprice" sortable min-width="260">
          <template slot-scope="scope">
            <span v-if="applelyInvoiceForm.type!=0">{{scope.row.unitprice}}&nbsp;&nbsp;({{scope.row.minprice}}-{{scope.row.maxprice}})</span>
            <p class="flexUpDownCenter" v-else>
              <el-input class="editIpt" v-model="scope.row.unitprice" @change="unitpriceChange(scope.row)" clearable size="medium"></el-input>
              <span class="pl10">({{scope.row.minprice}}-{{scope.row.maxprice}})</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="金额(￥)" prop="amount" sortable min-width="130">
          <template slot-scope="scope">
            <span>{{scope.row.amount | formatAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="税率(%)" prop="taxrate" sortable min-width="130">
          <template slot-scope="scope">
            <span>{{scope.row.taxrate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="税额合计(￥)" prop="taxamount" sortable min-width="150">
          <template slot-scope="scope">
            <span>{{scope.row.taxamount | formatAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="价税合计(￥)" prop="totalamount" sortable min-width="150">
          <template slot-scope="scope">
            <span>{{scope.row.totalamount | formatAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="70">
          <template slot-scope="scope">
            <p class="handle">
              <span title="删除" @click="deleteRow(scope.$index, createForm.haveSelectedData)"><i class="icondel"></i></span>
            </p>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData">
            <!-- <span>暂无数据</span> -->
            <p class="singleGoodsTip">亲，您尚未选择开票商品~，点击&nbsp;&nbsp;<em class="blueColor cursorHand" @click="openSelInvoice">选择开票商品&nbsp;&gt;</em></p>
          </div>
        </template>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <span class="ftDgTip">
          产品价税合计<em>￥{{totalMoney}}</em>
          <b v-if="balancePrice>0">，本次开票余额<em>￥{{balancePrice}}</em></b>
        </span>
        <el-button type="primary" @click="closeCreateInvBox(1)">确定</el-button>
        <el-button @click="closeCreateInvBox(0)">取消</el-button>
      </span>
    </el-dialog>
    <!--E 创建发票内容弹窗-->

    <!--S 选择开票商品弹窗-->
    <InvoiceGoods
    v-if="selInvoiceGoods"
    :packType="applelyInvoiceForm.type"
    :recordList="createForm.haveSelectedData"
    :InvoicePrice="createForm.totalAmount"
    :infocode="sellerInfo?sellerInfo.infocode:''"
    :selInvoiceGoodsShow="selInvoiceGoods"
    :operateType="1"
    :usedStockObj="editIndex == -1?usedStockList:transitStock"
    :detailUsedStock="recordCode?detailUsedStock:''"
    @closeSelInvoiceGoods="getCloseSelInvGoodsBox"></InvoiceGoods>
    <!--E 选择开票商品弹窗-->

  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
import Vue from 'vue';
export default {
  name: 'ApplyInvoicePage',
  data () {
    // const validatePass = (rule, value, callback) => {
    //   if (value > (sysCaninvoiceprice - alreadyInvoiceMoney)) { //判断条件
    //     callback(new Error('输入的金额已超出最高可开票金额'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      sysCaninvoiceprice: 0,//系统当前最高可开票金额
      invoiceMemberShow:false,//选择开票会员弹窗
      selTradeRoleShow:false,//选择买卖房弹窗
      roleType:0,//0：购买方，1：销售方
      roleoldVal:null,//表格上一次选中的数据
      applelyInvoiceForm:{
        type:0,//明细分类
        applymeno:'',//开票申请说明
        pkggoodsData:[],//发票明细项
        invmedium: 0, // 发票介质 1 为电子发票 0 为纸质发票
        email: '', // 邮箱
      },
      buyerInfo: '', // 购买方信息
      sellerInfo: '', // 销售方信息
      buyerOrsellerInfo: '', // 购买方/销售方编码

      createInvoiceItemShow:false,//创建发票内容弹窗
      createForm:{
        totalAmount:'',//本次开票价税总额
        invgoodsname:'',//产品名称
        invkindinfo:'',//规格型号
        taxrate:'',//产品税率
        taxamount:'',//税额总计
        unit:'',//单位
        amount:'',//产品金额
        unitprice:'',//产品单价
        num:1,
        haveSelectedData:[],//创业发票内容已选择的商品项
        toatalMinAmount: 0, // 最小区间的金额总和
        toatalMaxAmount: 0, // 最大区间的金额总和
        toatalMinPrice: 0, // 最小区间的金额总和
        toatalMaxPrice: 0, // 最大区间的金额总和
      },//创建发票内容项表单
      selInvoiceGoods:false,//选择开票商品弹窗
      memberCode: '', // 选中的会员编号
      bindMemberInfo: null, // 选中的会员信息
      detailcode: '', // 开票明细编号
      alreadyInvoiceMoney: 0, // 打包时记录的已经开票的总金额（用于添加或编辑打包商品时会员可开票金额展示计算用）
      currentMoney: 0, // 本次剩余的可开票金额
      transitMoney: 0, // 用于过渡的开票金额
      totalMoney: 0, // 开票商品总的金额
      pricetaxList: [], // 存贮开票商品分配的价税额列表
      editIndex: -1, // 编辑时的下标
      cacheList: [], // 缓存的数据的列表
      usedStockList: {}, // 已用调的库存集合
      delieveryRules: {
        totalAmount: [
          { required: true, message: "开票价税金额不能为空！", trigger: 'blur' },
          // { required: true, trigger: 'change', validator: validatePass }
        ],
        invgoodsname: [
          { required: true, message: "产品名称不能为空！", trigger: 'blur' }
        ],
        invkindinfo: [
          { required: true, message: "规格型号不能为空！", trigger: 'blur' }
        ],
        unit: [
          { required: true, message: "单位不能为空！", trigger: 'blur' }
        ]
      },
      applelyRules: {
        applymeno: [
          { required: true, message: "开票申请说明不能为空！", trigger: ['blur']},
        ]
      },
      firstTrue: true, // 防止多次点击
      recordCode: '', // 重新开票时的开票记录编号
      transitStock: {}, // 库存过渡集合
      automationList: [], // 半自动化需要递归处理的商品列表
      balancePrice: 0, // 本次开票余额
      allTotalMoney: 0, // 单品开票时的 开票总价
      detailUsedStock: {}, // 已开票详情-商品库存集合
      computedWay: 0, // 开票计算方式
      recordInfo: {}, // 编辑时 获取的开票信息
    }
  },
  filters: {
    //发票类型过滤
    invoiceTypeFilter(value){
      if (value == 0) {
        return '普通发票/个人';
      } else if (value == 1) {
        return '普通发票/公司';
      } else if (value == 2) {
        return '增值税发票';
      }
    },
  },
  components: {
    InvoiceMember: resolve => require(["@/components/InvoiceManage/InvoiceMember.vue"], resolve),//选择开票会员弹窗组件
    InvoiceGoods: resolve => require(["@/components/InvoiceManage/InvoiceGoods.vue"], resolve),//选择开票商品弹窗组件
    BuyerAndSellerPop: resolve => require(["@/components/InvoiceManage/BuyerAndSellerPop.vue"], resolve),//选择购买方/销售方组件
  },
  watch: {
    'createForm.totalAmount'(val) {
      this.createForm.totalAmount = this.amountChech(val);
      if(this.createForm.totalAmount&&this.$refs.creatForms) {
        this.$refs.creatForms.clearValidate('totalAmount');
      }
      // 对比销售方最大金额
      if(this.editIndex != -1) {
        if(Number(this.createForm.totalAmount)>(this.sysCaninvoiceprice - this.alreadyInvoiceMoney + Number(this.cacheList[this.editIndex].totalAmount))) {
          this.createForm.totalAmount = this.sysCaninvoiceprice - this.alreadyInvoiceMoney + Number(this.cacheList[this.editIndex].totalAmount)
        }
      } else {
        if(Number(this.createForm.totalAmount)>(this.sysCaninvoiceprice - this.alreadyInvoiceMoney)) {
          this.createForm.totalAmount =this.sysCaninvoiceprice - this.alreadyInvoiceMoney
        }
      }
      // if(this.applelyInvoiceForm.type ==1) {
      //   if(this.editIndex != -1) {
      //     if(Number(this.createForm.totalAmount)>(Number(this.bindMemberInfo.caninvoiceprice) - Number(this.alreadyInvoiceMoney)+Number(this.cacheList[this.editIndex].totalAmount))) {
      //       this.createForm.totalAmount = Number(this.bindMemberInfo.caninvoiceprice) - Number(this.alreadyInvoiceMoney)+Number(this.cacheList[this.editIndex].totalAmount)
      //     }
      //   } else {
      //     if(Number(this.createForm.totalAmount)>(Number(this.bindMemberInfo.caninvoiceprice) - Number(this.alreadyInvoiceMoney))) {
      //       this.createForm.totalAmount = Number(this.bindMemberInfo.caninvoiceprice) - Number(this.alreadyInvoiceMoney)
      //     }
      //   }
      // } else {
      //   if(Number(this.createForm.totalAmount)>Number(this.bindMemberInfo.caninvoiceprice)) {
      //     this.createForm.totalAmount = this.bindMemberInfo.caninvoiceprice
      //   }
      // }
      this.currentMoney = this.currentMoney + Number(this.createForm.totalAmount) - this.transitMoney;
      this.transitMoney = Number(this.createForm.totalAmount);
      if(val&&this.createForm.haveSelectedData.length>0) {
        // 开票商品价税计算
        this.countPricetax(this.createForm.haveSelectedData);
      }
      if(val&&this.createForm.taxrate) {
        this.createForm.taxamount = (Number(this.createForm.totalAmount) - Number(this.createForm.totalAmount)/(1+Number(this.createForm.taxrate)/100)).toFixed(2);
        this.createForm.amount = (Number(this.createForm.totalAmount)/(1+Number(this.createForm.taxrate)/100)).toFixed(2);
        this.createForm.unitprice = (Number(this.createForm.amount)/this.createForm.num).toFixed(8);
      } else {
        this.createForm.taxamount = '';
        this.createForm.amount = '';
        this.createForm.unitprice = '';
      }
    },
    'createForm.taxrate'(val) {
      if(val&&this.createForm.totalAmount) {
        this.createForm.taxamount = (Number(this.createForm.totalAmount) - Number(this.createForm.totalAmount)/(1+Number(val)/100)).toFixed(2);
        this.createForm.amount = (Number(this.createForm.totalAmount)/(1+Number(val)/100)).toFixed(2);
        this.createForm.unitprice = (Number(this.createForm.amount)/this.createForm.num).toFixed(8);
      } else {
        this.createForm.toatalMinAmount = 0; // 最小区间的金额总和
        this.createForm.toatalMaxAmount = 0; // 最大区间的金额总和
        this.createForm.toatalMinPrice = 0; // 最小区间的单价总和
        this.createForm.toatalMaxPrice = 0; // 最大区间的单价总和
        this.createForm.taxamount = '';
        this.createForm.amount = '';
        this.createForm.unitprice = '';
      }
    },
    'createForm.num'(val) {
      this.createForm.unitprice = (Number(this.createForm.amount)/Number(val)).toFixed(8);
    },
    'applelyInvoiceForm.invmedium'(val) {
      if(val != 1) {
        this.applelyInvoiceForm.email = '';
      }
    }
  },
  methods: {
    // 修改开票商品的单价 -------------------------------------------------------- 修改开票商品的单价S
    unitpriceChange(row) {
      row.unitprice = this.amountChech(row.unitprice);
      if(Number(row.unitprice)<Number(row.minprice)) {
        row.unitprice = row.minprice;
      }
      if(Number(row.unitprice)>Number(row.maxprice)) {
        row.unitprice = row.maxprice;
      }
      row.amount = (Number(row.unitprice)*row.num).toFixed(2);
      row.totalamount = (Number(row.unitprice)*row.num*(1+row.taxrate/100)).toFixed(2);
      row.taxamount = (Number(row.totalamount) - Number(row.amount)).toFixed(2);
      this.totalMoney = 0;
      this.createForm.haveSelectedData.forEach(item => {
        this.totalMoney = this.totalMoney + Number(item.totalamount);
      })
      this.totalMoney = Number(this.totalMoney.toFixed(2));
      if(this.totalMoney>=Number(this.createForm.totalAmount)) {
        this.balancePrice = 0;
      } else {
        this.balancePrice = (Number(this.createForm.totalAmount)-this.totalMoney).toFixed(2);
      }
    },
    amountChech(value) {
      let amount = String(value)
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        // .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //清除“数字”和“.”以外的字符
        amount = amount.replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d\d\d).*$/, "$1$2.$3");
      if (
        (amount > 0 &&
          (amount.indexOf(".") == -1 || !amount.startsWith("0"))) ||
        (amount.indexOf(".") == -1 && amount.length > 1)
      ) {
        //防止输入001 01格式
        if (amount.startsWith("0")) {
          amount = amount.substring(1);
        }
      }
      if(amount.indexOf(".") == 0) {
        amount = '';
      }
      return amount;
    },
    // 修改开票商品的单价 -------------------------------------------------------- 修改开票商品的单价E
    // 半自动化计算开票方法 --------------------------------------------------- 半自动化计算开票方法 S
    // 重置开票商品数量
    numReset() {
      this.createForm.haveSelectedData.forEach(item => {
        if(item.issuppdecimal ==1) {
          item.num = 0.1;
        } else {
          item.num = 1;
        }
      })
      this.createForm.haveSelectedData.sort(function(a, b) {
        return b.maxprice*b.num - a.maxprice*a.num;
      });
      this.countPricetax(this.createForm.haveSelectedData);
    },
    automationFun(arr) {
      let maxPricetax = 0; // 所有开票商品的最大价税和
      let minPricetax = 0; // 所有开票商品的最小价税和
      arr.forEach(item => {
        maxPricetax = maxPricetax + item.num*item.maxprice*(1+item.taxrate/100);
        minPricetax = minPricetax + item.num*item.minprice*(1+item.taxrate/100);
      })
      if(maxPricetax.toFixed(2) < Number(this.createForm.totalAmount)) {
        // this.totalMoney = maxPricetax.toFixed(2); // 开票商品总价税
        // arr.forEach(item => {
        //   item.unitprice = item.maxprice;
        //   item.amount = item.num*item.maxprice;
        //   item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
        //   item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
        // })
        if(arr.length>1) {
          this.balancePrice = Number(this.createForm.totalAmount);
          this.rejectStockGoods(arr);
        } else {
          let minNum = 1;
          let maxNum = 1;
          minNum = Math.floor(Number(this.createForm.totalAmount)/maxPricetax);
          maxNum = Math.floor(Number(this.createForm.totalAmount)/minPricetax);
          if((arr[0].issuppdecimal!=1&&(minNum>=arr[0].availableinv)) ||(arr[0].issuppdecimal==1&&(minNum*0.1>=arr[0].availableinv))) {
            arr.forEach(item => {
              item.num = item.availableinv;
              item.unitprice = item.maxprice;
              item.amount = item.num*item.maxprice;
              item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
              item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
            })
            this.totalMoney = Number(arr[0].totalamount);
            this.balancePrice = (Number(this.createForm.totalAmount)-this.totalMoney).toFixed(2);
            // 计算最大和最小区间和
            this.toatalFun(this.createForm.haveSelectedData);
          } else {
            if((arr[0].issuppdecimal==1&&(maxNum>(minNum + 0.1))) || (arr[0].issuppdecimal!=1&&(maxNum>(minNum + 1)))) {
              this.totalMoney = Number(this.createForm.totalAmount); // 开票商品总价税
              arr.forEach(item => {
                if(item.issuppdecimal==1) {
                  item.num = minNum*0.1 + 0.1;
                } else {
                  item.num = minNum + 1;
                }
                item.unitprice = (this.totalMoney/(item.num*(1+item.taxrate/100))).toFixed(8);
                item.amount = (this.totalMoney/(1+item.taxrate/100)).toFixed(2);
                item.taxamount = (this.totalMoney-item.amount).toFixed(2);
                item.totalamount = this.totalMoney;
              })
              this.balancePrice = 0;
              // 计算最大和最小区间和
              this.toatalFun(this.createForm.haveSelectedData);
            } else {
              arr.forEach(item => {
                item.num = minNum;
                item.unitprice = item.maxprice;
                item.amount = item.num*item.maxprice;
                item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
                item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
              })
              this.totalMoney = Number(arr[0].totalamount);
              this.balancePrice = (Number(this.createForm.totalAmount)-this.totalMoney).toFixed(2);
              // 计算最大和最小区间和
              this.toatalFun(this.createForm.haveSelectedData);
            }
          }
        }
      } else if(minPricetax.toFixed(2) > Number(this.createForm.totalAmount)) {
        this.totalMoney = minPricetax.toFixed(2); // 开票商品总价税
        this.balancePrice = 0;
        arr.forEach(item => {
          item.unitprice = item.minprice;
          item.amount = item.num*item.minprice;
          item.taxamount = item.num*item.minprice*(item.taxrate/100);
          item.totalamount = (item.num*item.minprice*(1+item.taxrate/100)).toFixed(2);
        })
        this.$message({
          type: 'error',
          message: '开票商品总额已经超过本次开票金额，请适当减少开票商品！'
        })
        // 计算最大和最小区间和
        this.toatalFun(arr);
      } else {
        // 计算最大和最小区间和
        this.toatalFun(arr);
        this.totalMoney = Number(this.createForm.totalAmount); // 开票商品总价税
        this.balancePrice = 0;
        if(maxPricetax.toFixed(2) == Number(this.createForm.totalAmount)) {
          arr.forEach(item => {
            item.unitprice = item.maxprice;
            item.amount = item.num*item.maxprice;
            item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
            item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
          })
        } else if(minPricetax.toFixed(2) == Number(this.createForm.totalAmount)) {
          arr.forEach(item => {
            item.unitprice = item.minprice;
            item.amount = item.num*item.minprice;
            item.taxamount = item.num*item.minprice*(item.taxrate/100);
            item.totalamount = (item.num*item.minprice*(1+item.taxrate/100)).toFixed(2);
          })
        } else {
          // 价税递归计算方法
          this.pricetaxList = [];
          this.recursionPricetax(arr);
        }
      }
    },
    // 剔除库存已满或者不足的商品
    rejectStockGoods(arr) {
      let stockGoodsList = []; // 库存充足的商品列表
      let rejectGoodsList = []; // 库存不足的商品列表
      let stockNum = 1;
      let maxPricetax = 0; // 所有开票商品的最大价税和
      let stockTrue = false; // 库存是否都满足
      let codeList = []; // 库存充足的商品code
      arr.forEach(item => {
        maxPricetax = maxPricetax + item.num*item.maxprice*(1+item.taxrate/100);
        codeList.push(item.invgoodscode);
      });
      stockNum = Math.floor(this.balancePrice/maxPricetax);
      this.createForm.haveSelectedData.forEach(item => {
        if(codeList.indexOf(item.invgoodscode)!=-1) {
          if((item.issuppdecimal!=1&&(item.availableinv<=stockNum*item.num)) || (item.issuppdecimal==1&&(item.availableinv<=stockNum*0.1))) {
            item.num = item.availableinv;
            item.unitprice = item.maxprice;
            item.amount = item.num*item.maxprice;
            item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
            item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
            stockTrue = true;
            rejectGoodsList.push(item);
          } else {
            stockGoodsList.push(item)
          }
        }
      });
      this.automationList = stockGoodsList;
      if(stockTrue) {
        maxPricetax = 0;
        rejectGoodsList.forEach(item => {
          maxPricetax = maxPricetax + item.num*item.maxprice*(1+item.taxrate/100);
        });
        this.balancePrice = this.balancePrice - maxPricetax;
        if(this.automationList.length>0) {
          this.rejectStockGoods(this.automationList);
          return false;
        } else {
          this.totalMoney = Number(maxPricetax).toFixed(2);
          this.balancePrice = Number(this.balancePrice).toFixed(2);
        }
      } else {
        if(this.balancePrice.toFixed(2)>0&&this.automationList.length>0) {
          maxPricetax = 0;
          this.automationList.forEach(item => {
            item.num = item.num*stockNum;
            maxPricetax = maxPricetax + item.num*item.maxprice*(1+item.taxrate/100);
          });
          this.balancePrice = this.balancePrice - maxPricetax;
          this.recursionFun(this.automationList);
        } else if((this.balancePrice.toFixed(2)>0)&&(this.automationList.length==0)) {
          // 计算最大和最小区间和
          this.toatalFun(this.createForm.haveSelectedData);
          this.$message({
            type: 'error',
            message: '开票商品库存不足，请从新选择开票商品！'
          })
        } else {
          let codeList = [];
          if(this.automationList.length>0) {
            this.automationList.forEach(item => {
              codeList.push(item.invgoodscode);
            });
          }
          maxPricetax = 0;
          this.createForm.haveSelectedData.forEach(item => {
            if(codeList.indexOf(item.invgoodscode)!=-1) {
              item.num = item.num*stockNum;
            }
            item.unitprice = item.maxprice;
            item.amount = item.num*item.maxprice;
            item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
            item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
            maxPricetax = maxPricetax + item.num*item.maxprice*(1+item.taxrate/100);
          });
          // this.totalMoney = Number(maxPricetax.toFixed(2));
          this.totalMoney = Number(this.createForm.totalAmount);
          this.balancePrice = 0;
          // 计算最大和最小区间和
          this.toatalFun(this.createForm.haveSelectedData);
        }
      }
    },
    // 自动计算递归
    recursionFun(arr) {
      let codeList = []; // 库存充足的商品code
      let maxPrices = 0; // 最大单价税和
      let minPrices = 0; // 最小单价税和
      let endCode = ''; // 计算结束时商品的code
      let endPrice = ''; // 计算结束时商品的最后分配价格
      let rejectGoodsList = []; // 库存不足的列表
      let rejectCodeList = []; // 库存不足的code
      let stockGoodsList = []; // 库存充足的列表
      let isTrue = false; // 是否分配结束
      arr.forEach(item => {
        codeList.push(item.invgoodscode);
        if(this.balancePrice>0) {
          if(item.issuppdecimal!=1) {
            maxPrices = 1*item.maxprice*(1+item.taxrate/100);
            minPrices = 1*item.minprice*(1+item.taxrate/100);
          } else {
            maxPrices = 0.1*item.maxprice*(1+item.taxrate/100);
            minPrices = 0.1*item.minprice*(1+item.taxrate/100);
          }
          if(maxPrices<this.balancePrice) {
            this.balancePrice = (this.balancePrice - maxPrices).toFixed(2);
            if(item.issuppdecimal!=1) {
              item.num+=1;
            } else {
              item.num+=0.1;
            }
          } else if((maxPrices>=this.balancePrice)&&(this.balancePrice>=minPrices)){
            endPrice = this.balancePrice;
            this.balancePrice = 0;
            if(item.issuppdecimal!=1) {
              item.num+=1;
            } else {
              item.num+=0.1;
            }
            endCode = item.invgoodscode;
            isTrue = true;
          }
        }
      })
      if(this.balancePrice>0) {
        arr.forEach(item => {
          if(item.num>=item.availableinv) {
            rejectGoodsList.push(item);
            rejectCodeList.push(item.invgoodscode);
          } else {
            stockGoodsList.push(item);
          }
        })
        if(stockGoodsList.length>0) {
          let info = stockGoodsList[stockGoodsList.length-1];
          if(info!=undefined&&info.issuppdecimal!=1) {
            minPrices = 1*info.minprice*(1+info.taxrate/100);
          } else {
            minPrices = 0.1*info.minprice*(1+info.taxrate/100);
          }
          if(this.balancePrice>=minPrices) {
            if(rejectGoodsList.length>0) {
              this.createForm.haveSelectedData.forEach.forEach(item => {
                if(rejectCodeList.indexOf(item.invgoodscode)!=-1) {
                  let index0 = rejectCodeList.indexOf(item.invgoodscode);
                  item.num = rejectGoodsList[index0].num;
                  item.unitprice = item.maxprice;
                  item.amount = item.num*item.maxprice;
                  item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
                  item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
                }
              })
            }
            this.recursionFun(stockGoodsList);
            return false;
          } else {
            isTrue = true;
          }
        } else {
          isTrue = true;
        }
      } else {
        isTrue = true;
      }
      if(isTrue = true) {
        let codeIndex = -1;
        let orterPrice = 0;
        this.createForm.haveSelectedData.forEach((item,index) => {
          if(endCode!=item.invgoodscode) {
            if(codeList.indexOf(item.invgoodscode)!=-1) {
              let indexs = codeList.indexOf(item.invgoodscode);
              item.num = arr[indexs].num;
              item.unitprice = item.maxprice;
              item.amount = item.num*item.maxprice;
              item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
              item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
            }
            if(this.balancePrice == 0) {
              orterPrice = orterPrice + Number(item.totalamount);
            }
          } else {
            let indexs = codeList.indexOf(endCode);
            codeIndex = index;
            // let endNum = 0;
            // if(item.issuppdecimal!=1) {
            //   endNum = arr[index].num-1;
            // } else {
            //   endNum = arr[index].num-0.1;
            // }
            // let maxPricetax = 0;
            item.num = arr[indexs].num;
            // maxPricetax = endNum*item.maxprice*(1+item.taxrate/100) + Number(endPrice);
            // console.log(maxPricetax,'maxPricetaxmaxPricetax')
            // item.totalamount = Number(maxPricetax).toFixed(2);
            // item.unitprice = (Number(maxPricetax)/(item.num*(1+item.taxrate/100))).toFixed(8);
            // item.amount = (Number(maxPricetax)/(1+item.taxrate/100)).toFixed(2);
            // item.taxamount = (Number(maxPricetax) - item.amount).toFixed(2);
          }
        });
        if(codeIndex!=-1) {
          let maxPricetax = (Number(this.createForm.totalAmount)-orterPrice).toFixed(2);
          let endNum = this.createForm.haveSelectedData[codeIndex].num;
          let taxrate = this.createForm.haveSelectedData[codeIndex].taxrate;
          this.createForm.haveSelectedData[codeIndex].totalamount = Number(maxPricetax);
          this.createForm.haveSelectedData[codeIndex].unitprice = (Number(maxPricetax)/(endNum*(1+taxrate/100))).toFixed(8);
          this.createForm.haveSelectedData[codeIndex].amount = (Number(maxPricetax)/(1+taxrate/100)).toFixed(2);
          this.createForm.haveSelectedData[codeIndex].taxamount = (Number(maxPricetax) - this.createForm.haveSelectedData[codeIndex].amount).toFixed(2);
        }
        if(this.balancePrice>0) {
          this.totalMoney = (Number(this.createForm.totalAmount) - Number(this.balancePrice)).toFixed(2);
          this.balancePrice = Number(this.balancePrice).toFixed(2);
          this.createForm.haveSelectedData.reverse();
        } else {
          this.totalMoney = Number(this.createForm.totalAmount);
        }
        // 计算最大和最小区间和
        this.toatalFun(this.createForm.haveSelectedData);
      }
    },
    // 计算最大和最小区间和
    toatalFun(arr) {
      if(this.applelyInvoiceForm.type == 1) {
        this.createForm.toatalMinAmount = 0; // 最小区间的金额总和
        this.createForm.toatalMaxAmount = 0; // 最大区间的金额总和
        this.createForm.toatalMinPrice = 0; // 最小区间的单价总和
        this.createForm.toatalMaxPrice = 0; // 最大区间的单价总和
        arr.forEach(item => {
          this.createForm.toatalMinAmount = this.createForm.toatalMinAmount + item.num*item.minprice; // 最小区间的金额总和
          this.createForm.toatalMaxAmount = this.createForm.toatalMaxAmount + item.num*item.maxprice; // 最大区间的金额总和
          this.createForm.toatalMinPrice = this.createForm.toatalMinPrice + item.minprice; // 最小区间的单价总和
          this.createForm.toatalMaxPrice = this.createForm.toatalMaxPrice + item.maxprice; // 最大区间的单价总和
        })
        this.createForm.toatalMinAmount = this.createForm.toatalMinAmount.toFixed(2); // 最小区间的金额总和
        this.createForm.toatalMaxAmount = this.createForm.toatalMaxAmount.toFixed(2); // 最大区间的金额总和
        this.createForm.toatalMinPrice = this.createForm.toatalMinPrice.toFixed(2); // 最小区间的单价总和
        this.createForm.toatalMaxPrice = this.createForm.toatalMaxPrice.toFixed(2); // 最大区间的单价总和
      }
    },
    // 半自动化计算开票方法 --------------------------------------------------- 半自动化计算开票方法 E

    // 设置全部开票
    setAllMoney() {
      if((this.bindMemberInfo.caninvoiceprice - this.alreadyInvoiceMoney)>0) {
        this.createForm.totalAmount = this.bindMemberInfo.caninvoiceprice - this.alreadyInvoiceMoney;
      } else {
        this.$message({
          type: 'warning',
          message: '剩余开票金额不足，请手动输入！'
        })
        this.createForm.totalAmount = 0;
      }
    },
    // 计算剩余库存方法
    countSurplusStock(row) {
      if(true) {
        return row.availableinv;
      } else {
        if(this.usedStockList[row.invgoodscode] != undefined) {
          if(this.editIndex == -1) {
            Vue.set(this.transitStock,row.invgoodscode,this.usedStockList[row.invgoodscode]);
            return this.usedStockList[row.invgoodscode];
          } else {
            if(this.transitStock[row.invgoodscode]!=undefined) {
              return this.transitStock[row.invgoodscode];
            } else {
              Vue.set(this.transitStock,row.invgoodscode,this.usedStockList[row.invgoodscode] + Number(row.num));
              return this.usedStockList[row.invgoodscode] + Number(row.num);
            }
          }
        } else {
          Vue.set(this.transitStock,row.invgoodscode,row.availableinv);
          return row.availableinv;
        }
      }
    },
    // 获取销售方最大金额
    getMaxprice() {
      let maxParams = {
        salercode: this.sellerInfo.infocode
      }
      if(this.recordCode&&(this.recordInfo.salercode == this.sellerInfo.infocode)) {
        maxParams.recordcode = this.recordCode;
      }
      api.GET_MAXPRICE(maxParams).then(res => {
        if(res.data.status == "200") {
          this.sysCaninvoiceprice = res.data.data?res.data.data:0
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      })
    },
    // 提交开票申请
    toSubmit() {
      if(this.firstTrue) {
        if(!this.buyerInfo) {
          this.$message({
            type: 'error',
            message: '请选择购买方！'
          })
          return false;
        }
        if(this.applelyInvoiceForm.pkggoodsData.length == 0) {
          this.$message({
            type: 'error',
            message: '请先选择开票商品！'
          })
          return false;
        }
        if(this.applelyInvoiceForm.applymeno === '') {
          this.$message({
            type: 'error',
            message: '请填写开票申请说明！'
          })
          return false;
        }
        if(this.applelyInvoiceForm.invmedium == 1&&this.applelyInvoiceForm.email!==''&&this.emailCheck(this.applelyInvoiceForm.email)==2){
          this.$message.error('电子邮箱错误！')
          return false;
        }
        let sumParams = {
          membercode: this.memberCode,
          salername: this.sellerInfo.name,
          salercode: this.sellerInfo.infocode,
          buyername: this.buyerInfo.name,
          buyercode: this.buyerInfo.infocode,
          type: this.applelyInvoiceForm.type,
          applymeno: this.applelyInvoiceForm.applymeno,
          invmedium: this.applelyInvoiceForm.invmedium,
          email: this.applelyInvoiceForm.email,
        }
        if(this.recordCode) {
          sumParams.recordcode = this.recordCode;
        }
        this.firstTrue = false;
        api.SUBINVOICERECORD(sumParams).then(res => {
          if(res.data.status == "200") {
            this.$message({
              type: 'success',
              message: res.data.message,
              offset: 200
            })
            this.$router.push({
              name: '会员申请开票列表'
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.message,
              offset: 200
            })
          }
          this.firstTrue = true;
        }).catch(res => {
          this.firstTrue = true;
        })
      }
    },
    // 开票商品价税计算
    countPricetax(arr) {
      let maxPricetax = 0; // 所有开票商品的最大价税和
      let minPricetax = 0; // 所有开票商品的最小价税和
      arr.forEach(item => {
        maxPricetax = maxPricetax + item.num*item.maxprice*(1+item.taxrate/100);
        minPricetax = minPricetax + item.num*item.minprice*(1+item.taxrate/100);
      })
      if(maxPricetax.toFixed(2) <= Number(this.createForm.totalAmount)) {
        this.totalMoney = maxPricetax.toFixed(2); // 开票商品总价税
        arr.forEach(item => {
          item.unitprice = item.maxprice;
          item.amount = item.num*item.maxprice;
          item.taxamount = item.num*item.maxprice*(item.taxrate/100).toFixed(2);
          item.totalamount = (item.num*item.maxprice*(1+item.taxrate/100)).toFixed(2);
        })
        this.balancePrice = (this.createForm.totalAmount - maxPricetax).toFixed(2);
      }
      if(minPricetax.toFixed(2) >= Number(this.createForm.totalAmount)) {
        this.totalMoney = minPricetax.toFixed(2); // 开票商品总价税
        arr.forEach(item => {
          item.unitprice = item.minprice;
          item.amount = item.num*item.minprice;
          item.taxamount = item.num*item.minprice*(item.taxrate/100);
          item.totalamount = (item.num*item.minprice*(1+item.taxrate/100)).toFixed(2);
        })
        this.balancePrice = 0;
      }
      if((maxPricetax.toFixed(2) > Number(this.createForm.totalAmount)) && (minPricetax.toFixed(2) < Number(this.createForm.totalAmount))) {
        this.totalMoney = Number(this.createForm.totalAmount); // 开票商品总价税
        this.balancePrice = 0;
        // 价税递归计算方法
        // 先清空之前保存的价税列表
        this.pricetaxList = [];
        this.recursionPricetax(arr);
      }
      // 计算最大和最小区间和
      this.toatalFun(arr);
    },
    // 价税递归计算方法
    recursionPricetax(arr) {
      let exceedPrice = 0; // 超出的价格
      let shortagePrice = 0; // 缺少的价格
      let exceedIndex = -1; // 超出的开票商品下标
      let shortageIndex = -1; // 缺少的开票商品下标
      let exceedNum001 = true; // 超出的开票商品 超出部分是否大于0.01
      let shortageNum001 = false; // 缺少的开票商品 缺少部分是否大于0.01
      if(this.pricetaxList.length>0) {
        let lastNum = 0;
        arr.forEach((item,index) => {
          let averagePrice = this.pricetaxList[index]; // 开票商品分配的价税额
          if(index != arr.length-1) {
            lastNum = lastNum + Number(averagePrice);
          } else {
            let priceLast = averagePrice
            // if(this.pricetaxList.length>0) {
            //   this.pricetaxList.forEach(item => {
                priceLast = Number(this.totalMoney) - Number(lastNum);
            //   })
            // }
            averagePrice = Number(priceLast.toFixed(2));
          }
          if(averagePrice > (item.num*item.maxprice*(1+item.taxrate/100))) {
            if((averagePrice-(item.num*item.maxprice*(1+item.taxrate/100)))>0.01) {
              exceedPrice = averagePrice - item.num*item.maxprice*(1+item.taxrate/100);
              exceedNum001 = true;
            } else {
              exceedNum001 = false;
              exceedPrice = 0.01;
            }
            exceedIndex = index;
          }
          if(averagePrice < (item.num*item.minprice*(1+item.taxrate/100))) {
            if((item.num*item.minprice*(1+item.taxrate/100) - averagePrice)>=0.01) {
              shortagePrice = item.num*item.minprice*(1+item.taxrate/100) - averagePrice;
              shortageNum001 = true;
            } else {
              shortagePrice = 0.01;
              shortageNum001 = false;
            }
            shortageIndex = index;
          }
          if((averagePrice <= (item.num*item.maxprice*(1+item.taxrate/100)))&&(averagePrice >= (item.num*item.minprice*(1+item.taxrate/100)))) {
            // if(index == arr.length-1) {
            //   averagePrice = Number((Number(this.totalMoney) - lastNum).toFixed(2));
            // }
            item.unitprice = (averagePrice/item.num/(1+item.taxrate/100)).toFixed(8);
            item.amount = (averagePrice/(1+item.taxrate/100)).toFixed(2);
            item.taxamount = (averagePrice - item.amount).toFixed(2);
            item.totalamount = Number(averagePrice).toFixed(2);
          }
        })
        if(exceedIndex !=-1 || shortageIndex !=-1) {
          if(exceedIndex !=-1&&shortageIndex !=-1) {
            this.pricetaxList[exceedIndex] = Number(this.pricetaxList[exceedIndex]) - exceedPrice;
            // this.pricetaxList[exceedIndex] = arr[exceedIndex].num*arr[exceedIndex].maxprice*(1+arr[exceedIndex].taxrate/100);
            this.pricetaxList[shortageIndex] = Number(this.pricetaxList[shortageIndex]) + exceedPrice;
          } else if(exceedIndex !=-1) {
            if(exceedNum001) {
              this.pricetaxList[exceedIndex] = arr[exceedIndex].num*arr[exceedIndex].maxprice*(1+arr[exceedIndex].taxrate/100);
            } else {
              this.pricetaxList[exceedIndex] = arr[exceedIndex].num*arr[exceedIndex].maxprice*(1+arr[exceedIndex].taxrate/100) - exceedPrice;
            }
            let surplusPrice = exceedPrice;
            arr.some((item,index) => {
              if(exceedIndex != index) {
                let andPrice = Number((Number(this.pricetaxList[index]) + surplusPrice).toFixed(2));
                if((andPrice <= (item.maxprice*item.num*(1+item.taxrate/100)))&&(andPrice>=(item.minprice*item.num*(1+item.taxrate/100)))) {
                  this.pricetaxList[index] = andPrice;
                  return true;
                } else {
                  surplusPrice = andPrice - (item.maxprice*item.num*(1+item.taxrate/100));
                  this.pricetaxList[index] = item.maxprice*item.num*(1+item.taxrate/100);
                }
              }
              // let andPrice = (exceedPrice/item.num/(1+item.taxrate/100)) + item.unitprice; // 超出部分算出的单价与当前单价的和
              // if((andPrice <= item.maxprice)&&(andPrice >= item.minprice)) {
              //   this.pricetaxList[index] = this.pricetaxList[index] + exceedPrice;
              //   return true;
              // }
            })
          } else {
            if(shortageNum001) {
              this.pricetaxList[shortageIndex] = arr[shortageIndex].num*arr[shortageIndex].minprice*(1+arr[shortageIndex].taxrate/100);
            } else {
              this.pricetaxList[shortageIndex] = arr[shortageIndex].num*arr[shortageIndex].minprice*(1+arr[shortageIndex].taxrate/100)+0.01;
            }
            let surplusPrice = shortagePrice;
            arr.some((item,index) => {
              if(shortageIndex != index) {
                let andPrice = Number((Number(this.pricetaxList[index]) - surplusPrice).toFixed(2));
                if((andPrice <= (item.maxprice*item.num*(1+item.taxrate/100)))&&(andPrice>=(item.minprice*item.num*(1+item.taxrate/100)))) {
                  this.pricetaxList[index] = andPrice;
                  return true;
                } else {
                  surplusPrice = (item.minprice*item.num*(1+item.taxrate/100)) - andPrice;
                  this.pricetaxList[index] = item.minprice*item.num*(1+item.taxrate/100);
                }
              }
              // let andPrice = item.unitprice - (exceedPrice/item.num/(1+item.taxrate/100)); // 超出部分算出的单价与当前单价的差
              // if((andPrice <= item.maxprice)&&(andPrice >= item.minprice)) {
              //   this.pricetaxList[index] = this.pricetaxList[index] - shortagePrice;
              //   return true;
              // }
            })
          }
          this.recursionPricetax(arr);
        }
      } else {
        let averageTotal = 0; // 总的平均值
        arr.forEach(item => {
          averageTotal = averageTotal + ((item.minprice + item.maxprice)/2)*item.num*(1+item.taxrate/100);
        })
        let lastNum = 0;
        arr.forEach((item,index) => {
          let singlePrice = ((item.minprice + item.maxprice)/2)*item.num*(1+item.taxrate/100); // 开票商品平均值
          let averagePrice = Number(this.createForm.totalAmount*(singlePrice/averageTotal).toFixed(2)); // 开票商品分配的价税额
          if(index != arr.length-1) {
            lastNum = lastNum + averagePrice;
          } else {
            let priceLast = averagePrice
            // if(this.pricetaxList.length>0) {
            //   this.pricetaxList.forEach(item => {
                priceLast = Number(this.totalMoney) - Number(lastNum);
              // })
            // }
            averagePrice = Number(priceLast.toFixed(2));
          }
          this.pricetaxList.push(averagePrice);
          if(averagePrice > (item.num*item.maxprice*(1+item.taxrate/100))) {
            if((averagePrice-(item.num*item.maxprice*(1+item.taxrate/100)))>=0.01) {
              exceedPrice = averagePrice - item.num*item.maxprice*(1+item.taxrate/100);
              exceedNum001 = true;
            } else {
              exceedNum001 = false;
              exceedPrice = 0.01;
            }
            exceedIndex = index;
          }
          if(averagePrice < (item.num*item.minprice*(1+item.taxrate/100))) {
            if((item.num*item.minprice*(1+item.taxrate/100) - averagePrice)>=0.01) {
              shortagePrice = item.num*item.minprice*(1+item.taxrate/100) - averagePrice;
              shortageNum001 = true;
            } else {
              shortagePrice = 0.01;
              shortageNum001 = false;
            }
            shortageIndex = index;
          }
          if((averagePrice <= (item.num*item.maxprice*(1+item.taxrate/100)))&&(averagePrice >= (item.num*item.minprice*(1+item.taxrate/100)))) {
            // if(index == arr.length-1) {
            //   averagePrice = Number((Number(this.totalMoney) - Number(lastNum)).toFixed(2));
            // }
            item.unitprice = (averagePrice/item.num/(1+item.taxrate/100)).toFixed(8);
            item.amount = (averagePrice/(1+item.taxrate/100)).toFixed(2);
            item.taxamount = (averagePrice - item.amount).toFixed(2);
            item.totalamount = Number(averagePrice).toFixed(2);
          }
        })
        if(exceedIndex !=-1 || shortageIndex !=-1) {
          if(exceedIndex !=-1&&shortageIndex !=-1) {
            this.pricetaxList[exceedIndex] = Number(this.pricetaxList[exceedIndex]) - exceedPrice;
            this.pricetaxList[shortageIndex] = Number(this.pricetaxList[shortageIndex]) + exceedPrice;
          } else if(exceedIndex !=-1) {
            if(exceedNum001) {
              this.pricetaxList[exceedIndex] = arr[exceedIndex].num*arr[exceedIndex].maxprice*(1+arr[exceedIndex].taxrate/100);
            } else {
              this.pricetaxList[exceedIndex] = arr[exceedIndex].num*arr[exceedIndex].maxprice*(1+arr[exceedIndex].taxrate/100) - exceedPrice;
            }
            let surplusPrice = exceedPrice;
            arr.some((item,index) => {
              if(exceedIndex != index) {
                let andPrice = Number((Number(this.pricetaxList[index]) + surplusPrice).toFixed(2));
                if((andPrice <= (item.maxprice*item.num*(1+item.taxrate/100)))&&(andPrice>=(item.minprice*item.num*(1+item.taxrate/100)))) {
                  this.pricetaxList[index] = andPrice;
                  return true;
                } else {
                  surplusPrice = andPrice - (item.maxprice*item.num*(1+item.taxrate/100));
                  this.pricetaxList[index] = item.maxprice*item.num*(1+item.taxrate/100);
                }
              }
              // let andPrice = (exceedPrice/item.num/(1+item.taxrate/100)) + (this.pricetaxList[index]/item.num/(1+item.taxrate/100)); // 超出部分算出的单价与当前单价的和
              // if((andPrice <= item.maxprice)&&(andPrice >= item.minprice)) {
              //   this.pricetaxList[index] = this.pricetaxList[index] + exceedPrice;
              //   return true;
              // }
            })
          } else {
            if(shortageNum001) {
              this.pricetaxList[shortageIndex] = arr[shortageIndex].num*arr[shortageIndex].minprice*(1+arr[shortageIndex].taxrate/100);
            } else {
              this.pricetaxList[shortageIndex] = arr[shortageIndex].num*arr[shortageIndex].minprice*(1+arr[shortageIndex].taxrate/100)+0.01;
            }
            let surplusPrice = shortagePrice;
            arr.some((item,index) => {
              if(shortageIndex != index) {
                let andPrice = Number((Number(this.pricetaxList[index]) - surplusPrice).toFixed(2));
                if((andPrice <= (item.maxprice*item.num*(1+item.taxrate/100)))&&(andPrice>=(item.minprice*item.num*(1+item.taxrate/100)))) {
                  this.pricetaxList[index] = andPrice;
                  return true;
                } else {
                  surplusPrice = (item.minprice*item.num*(1+item.taxrate/100)) - andPrice;
                  this.pricetaxList[index] = item.minprice*item.num*(1+item.taxrate/100);
                }
              }
              // let andPrice = (this.pricetaxList[index]/item.num/(1+item.taxrate/100)) - (shortagePrice/item.num/(1+item.taxrate/100)); // 超出部分算出的单价与当前单价的差
              // if((andPrice <= item.maxprice)&&(andPrice >= item.minprice)) {
              //   this.pricetaxList[index] = this.pricetaxList[index] - shortagePrice;
              //   return true;
              // }
            })
          }
          this.recursionPricetax(arr);
        }
      }
    },
    // 改变开票商品数量方法
    numChange(info) {
      if(this.computedWay == 1) {
        this.unitpriceChange(info);
        return false;
      }
      if(info.num) {
        // 开票商品价税计算
        this.countPricetax(this.createForm.haveSelectedData);
      }
    },
    // 打开选择开票商品弹窗
    openSelInvoice() {
      if(!this.createForm.totalAmount) {
        this.$message({
          type: 'error',
          message: '请先选择需要开票的金额！',
          offset: 200
        })
        return false;
      }
      this.selInvoiceGoods = true;
    },
    // 开票明细类型改变方法
    packTypeChange(val) {
      if(val != this.applelyInvoiceForm.type) {
        if(this.applelyInvoiceForm.pkggoodsData.length>0){
          MessageBox.confirm('更改明细类型会清空已选商品项，确定更改?', '确认提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.applelyInvoiceForm.type = val;
            // 缓存初始化接口
            this.initGoodsCache();
          }).catch(()=>{
          });
        } else {
          this.applelyInvoiceForm.type = val;
          // 缓存初始化接口
          this.initGoodsCache();
        }
      }
    },
    //打开选择买卖方弹窗
    selTradeRole(val,type){
      this.roleType=val;
      this.buyerOrsellerInfo = val==0?this.buyerInfo:this.sellerInfo;
      if(type == 'edit') {
        if(val == 1&&this.applelyInvoiceForm.pkggoodsData.length>0) {
          MessageBox.confirm('更改明细类型会清空已选商品项，确定更改?', '确认提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.selTradeRoleShow = true;
          }).catch(()=>{
          });
        } else {
          this.selTradeRoleShow = true;
        }
      } else {
        this.selTradeRoleShow = true;
      }
    },
    // 关闭购买方/销售方弹窗
    closebasPop(val) {
      if(val) {
        if(this.roleType == 0) {
          this.buyerInfo = val;
        } else {
          if(this.sellerInfo.infocode != val.infocode) {
            // 缓存初始化接口
            this.initGoodsCache();
          }
          // 获取销售方最大开票金额
          this.sellerInfo = val;
          this.getMaxprice();
        }
        this.buyerOrsellerInfo = val;
      }
      this.selTradeRoleShow = false;
    },
    //清空发票内容项
    emptyInvGoods(){
      MessageBox.confirm('确定清除已选商品项?', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '清除成功!',
          offset: 200
        });
        this.applelyInvoiceForm.pkggoodsData=[];
        this.createForm.haveSelectedData = [];
        // 缓存初始化接口
        this.initGoodsCache();
      }).catch(()=>{});
    },
    //创建发票内容弹窗-删除商品项
    deleteRow(index,rows,type){
      MessageBox.confirm('确定删除该商品项?', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(type == '删除') {
          api.REMOVEGOODSCACHE({
            membercode: this.memberCode,
            detailcode: rows[index].detailcode
          }).then(res => {
            if(res.data.status == "200") {
              this.$message({
                type: 'success',
                message: '删除成功!',
                offset: 200
              });
              this.alreadyInvoiceMoney = (this.alreadyInvoiceMoney - Number(this.cacheList[index].totalAmount)).toFixed(2);
              this.cacheList[index].haveSelectedData.forEach(item => {
                this.usedStockList[item.invgoodscode] = this.usedStockList[item.invgoodscode] + Number(item.num);
              })
              rows.splice(index,1);
              this.cacheList.splice(index,1);
              if(this.cacheList.length == 0) {
                this.usedStockList = {};
              }
            } else {
              this.$message({
                type: 'success',
                message: res.data.message,
                offset: 200
              });
            }
          })
        } else {
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
          rows.splice(index,1);
          if(rows.length>0) {
            // 开票商品价税计算
            this.countPricetax(this.createForm.haveSelectedData);
          } else {
            this.createForm.taxrate = '';
            this.totalMoney = 0;
            this.balancePrice = 0;
          }
        }
      }).catch(()=>{});
    },
    // 打开创建发票内容弹窗
    openCreateInvoice(val,index) {
      if(!this.sellerInfo) {
        this.$message({
          type: 'warning',
          message: '请先选择销售方！',
          offset: 200
        })
      } else {
        this.computedWay = 0;
        this.transitStock = {};
        if(val) {
          this.editIndex = index;
          this.detailcode = val;
        } else {
          this.editIndex = -1;
          this.detailcode = '';
        }
        if(this.cacheList.length>0&&((this.applelyInvoiceForm.type==1&&this.detailcode) || this.applelyInvoiceForm.type==0)) {
          if(this.detailcode) {
            this.createForm ={
              totalAmount:this.cacheList[this.editIndex].totalAmount,//本次开票价税总额
              invgoodsname:this.cacheList[this.editIndex].invgoodsname,//产品名称
              invkindinfo:this.cacheList[this.editIndex].invkindinfo,//规格型号
              taxrate:this.cacheList[this.editIndex].taxrate,//产品税率
              taxamount:this.cacheList[this.editIndex].taxamount,//税额总计
              unit:this.cacheList[this.editIndex].unit,//单位
              amount:this.cacheList[this.editIndex].amount,//产品金额
              unitprice:this.cacheList[this.editIndex].unitprice,//产品单价
              num:this.cacheList[this.editIndex].num,
              haveSelectedData:this.cacheList[this.editIndex].haveSelectedData,//创业发票内容已选择的商品项
              toatalMinAmount: this.cacheList[this.editIndex].toatalMinAmount, // 最小区间的金额总和
              toatalMaxAmount: this.cacheList[this.editIndex].toatalMaxAmount, // 最大区间的金额总和
              toatalMinPrice: this.cacheList[this.editIndex].toatalMinPrice, // 最小区间的金额总和
              toatalMaxPrice: this.cacheList[this.editIndex].toatalMaxPrice, // 最大区间的金额总和
            }
            // this.createForm = this.cacheList[this.editIndex];
          } else {
            this.createForm.totalAmount = this.totalMoney;
            this.createForm.haveSelectedData = this.cacheList[0];
          }
        } else {
          this.createForm ={
            totalAmount:'',//本次开票价税总额
            invgoodsname:'',//产品名称
            invkindinfo:'',//规格型号
            taxrate:'',//产品税率
            taxamount:'',//税额总计
            unit:'',//单位
            amount:'',//产品金额
            unitprice:'',//产品单价
            num:1,
            haveSelectedData:[],//创业发票内容已选择的商品项
            toatalMinAmount: 0, // 最小区间的金额总和
            toatalMaxAmount: 0, // 最大区间的金额总和
            toatalMinPrice: 0, // 最小区间的金额总和
            toatalMaxPrice: 0, // 最大区间的金额总和
          };
          this.totalMoney = 0; // 开票金额总和
        }
        // 调用明细缓存信息
        // this.getGoodsCache();
        this.createInvoiceItemShow = true;
        setTimeout(() => {
          this.$refs.creatForms.clearValidate();
        }, 300);
      }
    },
    //关闭创建发票内容弹窗
    closeCreateInvBox(val){
      if(val==1){
        if(this.firstTrue) {
          if(!this.createForm.totalAmount) {
            this.$message({
              type: 'error',
              message: '开票金额不能小于0！'
            })
            return false;
          }
          if(this.createForm.haveSelectedData.length==0) {
            this.$message({
              type: 'error',
              message: '请先选择开票商品！'
            })
            return false;
          }
          if(Number(this.createForm.totalAmount) != Number(this.totalMoney)) {
            this.$message({
              type: 'error',
              message: '所选开票商品的价税合计与本次开票价税金额不符！'
            })
            return false;
          }
          if(this.applelyInvoiceForm.type == 1) {
            if(this.createForm.invgoodsname === '') {
              this.$message({
                type: 'error',
                message: '请填写产品名称！'
              })
              return false;
            }
            if(this.createForm.invkindinfo === '') {
              this.$message({
                type: 'error',
                message: '请填写规格型号！'
              })
              return false;
            }
            if(this.createForm.unit === '') {
              this.$message({
                type: 'error',
                message: '请填写单位！'
              })
              return false;
            }
            if(this.createForm.num>1) {
              let numMessage = '';
              if(this.createForm.haveSelectedData.length>0) {
                this.createForm.haveSelectedData.some(item => {
                  if(item.issuppdecimal!=1) {
                    if(item.num<this.createForm.num) {
                      numMessage = `开票商品${item.invgoodsname} ${item.invkindinfo}的数量不能小于打包产品数量`;
                      return true;
                    }
                  }
                })
                if(numMessage) {
                  this.$message({
                    type: 'error',
                    message: numMessage
                  })
                  return false;
                }
              }
            }
          }
          let subParams = {
            membercode: this.memberCode,
            type: this.applelyInvoiceForm.type,
            amount: this.createForm.totalAmount,
          };
          let singleList = [];
          if(this.createForm.haveSelectedData.length>0) {
            this.createForm.haveSelectedData.forEach(item => {
              let info = {
                invgoodscode: item.invgoodscode,
                num: item.num,
                unitprice: item.unitprice,
                amount: item.amount,
                taxamount: item.taxamount,
              }
              singleList.push(info);
            })
          }
          if(this.applelyInvoiceForm.type == 1) {
            subParams.pkggoods = {
              invgoodsname: this.createForm.invgoodsname,
              invkindinfo: this.createForm.invkindinfo,
              num: this.createForm.num,
              unit: this.createForm.unit,
              unitprice: this.createForm.unitprice,
              amount: this.createForm.amount,
              taxrate: this.createForm.taxrate,
              taxamount: this.createForm.taxamount,
            }
            subParams.pkggoods.singlegoods = singleList;
            if(this.detailcode) {
              subParams.pkggoods.detailcode = this.detailcode;
            }
          } else {
            subParams.singlegoods = singleList;
          }
          if(this.recordCode) {
            subParams.recordcode = this.recordCode;
          }
          this.firstTrue = false;
          api.SAVEGOODSCACHE(subParams).then(res => {
            if(res.data.status == "200") {
              if(this.applelyInvoiceForm.type ==1) {
                if(this.editIndex !=-1) {
                  this.alreadyInvoiceMoney = (Number(this.alreadyInvoiceMoney) - Number(this.cacheList[this.editIndex].totalAmount) + Number(this.createForm.totalAmount)).toFixed(2);
                  let oldCodes = [];
                  let newCodes = [];
                  this.cacheList[this.editIndex].haveSelectedData.forEach(item => {
                    newCodes.push(item.invgoodscode);
                  })
                  this.createForm.haveSelectedData.forEach(item => {
                    oldCodes.push(item.invgoodscode);
                    let oldIndex = newCodes.indexOf(item.invgoodscode);
                    if(this.usedStockList[item.invgoodscode]!=undefined) {
                      if(oldIndex!=-1) {
                        console.log(this.usedStockList[item.invgoodscode],Number(this.cacheList[this.editIndex].haveSelectedData[oldIndex].num),Number(item.num),'00111')
                        this.usedStockList[item.invgoodscode] = Number(this.cacheList[this.editIndex].haveSelectedData[oldIndex].num) + this.usedStockList[item.invgoodscode] - Number(item.num);
                        console.log(this.usedStockList[item.invgoodscode],'22222')
                      } else {
                        this.usedStockList[item.invgoodscode] = this.usedStockList[item.invgoodscode] - Number(item.num);
                      }
                    } else {
                      Vue.set(this.usedStockList,item.invgoodscode,Number(item.availableinv) - Number(item.num))
                    }
                  })
                  this.cacheList[this.editIndex].haveSelectedData.forEach((item,index) => {
                    if(oldCodes.indexOf(item.invgoodscode)==-1) {
                      this.usedStockList[item.invgoodscode] = this.usedStockList[item.invgoodscode] + Number(item.num);
                    }
                  })
                  this.cacheList[this.editIndex] = this.createForm;
                } else {
                  this.alreadyInvoiceMoney = (Number(this.alreadyInvoiceMoney) + Number(this.createForm.totalAmount)).toFixed(2);
                  this.createForm.haveSelectedData.forEach(item => {
                    if(this.usedStockList[item.invgoodscode]!=undefined) {
                      this.usedStockList[item.invgoodscode] = this.usedStockList[item.invgoodscode] - Number(item.num);
                    } else {
                      Vue.set(this.usedStockList,item.invgoodscode,Number(item.availableinv) - Number(item.num))
                    }
                  })
                  this.cacheList.unshift(this.createForm);
                }
              } else {
                this.cacheList = [];
                this.cacheList.unshift(this.createForm.haveSelectedData);
                this.balancePrice = 0;
                this.allTotalMoney = this.createForm.totalAmount;
              }
              this.editIndex =-1;
              this.detailcode = '';
              // 调用明细缓存信息
              this.getGoodsCache();
              this.$refs.creatForms.clearValidate();
              this.createInvoiceItemShow = false;
              this.transitStock = {};
              this.firstTrue = true;
            } else {
              this.$message({
                type: 'error',
                message: res.data.message,
                offset: 200
              })
              this.firstTrue = true;
            }
          }).catch(res => {
            this.firstTrue = true;
          })
        }
      } else {
        if(this.applelyInvoiceForm.type == 0&&this.applelyInvoiceForm.pkggoodsData.length==0) {
          this.allTotalMoney = 0;
          this.balancePrice = 0;
        }
        this.$refs.creatForms.clearValidate();
        this.createInvoiceItemShow = false;
        this.transitStock = {};
      }
    },
    //关闭选择开票商品弹窗
    getCloseSelInvGoodsBox(arr){
      if(arr){
        if(arr.length>0) {
          let selectedCodes = [];
          let newDatas = [];
          if(this.createForm.haveSelectedData.length>0) {
            arr.forEach(item => {
              selectedCodes.push(item.invgoodscode);
            })
            this.createForm.haveSelectedData.forEach(item => {
              if(selectedCodes.indexOf(item.invgoodscode)!=-1) {
                let index = selectedCodes.indexOf(item.invgoodscode)
                selectedCodes.splice(index,1,' ');
                let selectedDataInfo = this.splitEle(item);
                newDatas.push(selectedDataInfo);
              }
            })
            this.createForm.haveSelectedData = newDatas;
            arr.forEach(item => {
              if(selectedCodes.indexOf(item.invgoodscode)!=-1) {
                let selectedDataInfo = this.splitEle(item);
                this.createForm.haveSelectedData.push(selectedDataInfo);
              }
            })
          } else {
            arr.forEach(item => {
              let selectedDataInfo = this.splitEle(item);
              this.createForm.haveSelectedData.push(selectedDataInfo);
            })
          }
          this.createForm.haveSelectedData = this.createForm.haveSelectedData.sort(function(a, b) {
            return b.maxprice*b.num - a.maxprice*a.num;
          })
          console.log(this.createForm.haveSelectedData,'this.createForm.haveSelectedDatathis.createForm.haveSelectedData')
          this.createForm.taxrate = this.createForm.haveSelectedData[0].taxrate;
          // 开票商品价税计算
          this.automationFun(this.createForm.haveSelectedData);
          // this.countPricetax(this.createForm.haveSelectedData);
        } else {
          this.createForm.taxrate = '';
          this.totalMoney = 0;
          this.createForm.haveSelectedData = [];
        }
        this.computedWay = 0;
      }
      this.selInvoiceGoods = false;
    },
    // 分装列表元素字段
    splitEle(info) {
      let selectedDataInfo = {
        invgoodsname: info.invgoodsname,
        invkindinfo: info.invkindinfo,
        num: info.issuppdecimal!=1?1:0.1,
        unit: info.unit,
        availableinv: info.availableinv,
        unitprice: '',
        amount: '',
        taxrate: info.taxrate,
        taxamount: '',
        minprice: info.minprice,
        maxprice:  info.maxprice,
        invgoodscode: info.invgoodscode,
        issuppdecimal: info.issuppdecimal,
        totalamount: '',
      }
      return selectedDataInfo;
    },
    // 获取会员基本信息
    getMemberDetail() {
      api.GET_INVOICEMEMBERLIST({membercode: this.memberCode}).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.bindMemberInfo = res.data.data[0];
            if(this.recordCode) {
              // 获取开票详情
              this.getInvoiceRecordDetail();
            }
          } else {
            this.$message({
              type: 'error',
              message: '未查到对应会员信息！'
            })
          }
        } else {
          this.$message({
              type: 'error',
              message: res.data.message
            })
        }
      })
    },
    // 接收选中的会员信息
    memberSelected: function(info) {
      if(info&&info.membercode != this.memberCode) {
        sessionStorage.setItem('invoiceMemberCode',info.membercode);
        this.bindMemberInfo = info;
        window.location.reload();
      }
      this.invoiceMemberShow = false;
    },
    // 缓存初始化接口
    initGoodsCache(code) {
      let initParams = {
        membercode: this.memberCode
      }
      if(code) {
        initParams.recordcode = code;
      }
      api.INITGOODSCACHE(initParams).then(res => {
        if(res.data.status!= '200') {
          this.$message({
            type: 'error',
            message: res.data.message,
            offset: 200
          })
        } else {
          if(code) {
          //   // 调用明细缓存信息
          //   this.getGoodsCache()
          } else {
            // 清空开票表单数据
            this.closeInvoiceFrom()
          }
        }
      })
    },
    // 修改会员
    updateMember() {
      MessageBox.confirm('更改会员后，页面将会重新加载！', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.invoiceMemberShow = true;
      }).catch(()=>{
        return false
      });
    },
    // 清空开票表单数据
    closeInvoiceFrom() {
      this.createForm ={
        totalAmount:'',//本次开票价税总额
        invgoodsname:'',//产品名称
        invkindinfo:'',//规格型号
        taxrate:'',//产品税率
        taxamount:'',//税额总计
        unit:'',//单位
        amount:'',//产品金额
        unitprice:'',//产品单价
        num:1,
        haveSelectedData:[],//创业发票内容已选择的商品项
        toatalMinAmount: 0, // 最小区间的金额总和
        toatalMaxAmount: 0, // 最大区间的金额总和
        toatalMinPrice: 0, // 最小区间的金额总和
        toatalMaxPrice: 0, // 最大区间的金额总和
      };
      this.editIndex = -1;
      this.detailcode = '';
      this.applelyInvoiceForm.applymeno = '';//开票申请说明
      this.applelyInvoiceForm.pkggoodsData = [];//发票明细项
      // this.applelyInvoiceForm.invmedium = 0;
      // this.applelyInvoiceForm.email = '';
      this.cacheList = []; // 缓存列表清空
      this.totalMoney = 0; // 开票金额总和
      this.allTotalMoney = 0;
      this.balancePrice = 0; // 余额
      this.alreadyInvoiceMoney = 0;
      this.usedStockList = {}; // 已用调的库存集合
      this.$refs.applelyForm.clearValidate();
    },
    // 调用明细缓存信息
    getGoodsCache(code) {
      let cacheParams = {
        membercode: this.memberCode
      }
      // if(this.detailcode && this.applelyInvoiceForm.type == 1) {
      //   cacheParams.detailcode = this.detailcode;
      // }
      api.GET_GOODSCACHE(cacheParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            if(code) {
              if(this.applelyInvoiceForm.type == 1) {
                res.data.data.forEach((item,index) => {
                  // 组装开票商品列表数据
                  let splitFormEle = this.splitFormEle(item);
                  this.cacheList.push(splitFormEle);
                  this.getInsideGoodsCache(item.detailcode,index,res.data.data.length);
                })
              } else {
                // 组装开票表单数据
                let isForm ={
                  haveSelectedData: [],//创业发票内容已选择的商品项
                };
                let codes = ''; // 拼接开票商品的code
                res.data.data.forEach(item => {
                  // 组装开票商品列表数据
                  let selectedDataInfo = this.splitDetailEle(item);
                  isForm.haveSelectedData.push(selectedDataInfo);
                  if(codes) {
                    codes = codes + ',' + item.invgoodscode;
                  } else {
                    codes = item.invgoodscode;
                  }
                  Vue.set(this.detailUsedStock,item.invgoodscode,item.num);
                })
                this.cacheList.push(isForm.haveSelectedData);
                // 获取开票商品列表信息
                this.getInvgoodsinfoList(codes,0);
              }
            }
            this.applelyInvoiceForm.pkggoodsData = res.data.data;
          }
        }
      })
    },
    // 调用明细缓存信息
    getInsideGoodsCache(code,findex,flength) {
      let cacheParams = {
        membercode: this.memberCode,
        detailcode: code
      }
      api.GET_GOODSCACHE(cacheParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            let codes = ''; // 拼接开票商品的code
            res.data.data.forEach(item => {
              // 组装开票商品列表数据
              let selectedDataInfo = this.splitDetailEle(item);
              this.cacheList[findex].haveSelectedData.push(selectedDataInfo);
              if(codes) {
                codes = codes + ',' + item.invgoodscode;
              } else {
                codes = item.invgoodscode;
              }
              if(this.detailUsedStock[item.invgoodscode]) {
                this.detailUsedStock[item.invgoodscode] = this.detailUsedStock[item.invgoodscode] + item.num;
              } else {
                Vue.set(this.detailUsedStock,item.invgoodscode,item.num);
              }
            })
            this.getInvgoodsinfoList(codes,findex,flength);
          }
        }
      })
    },
    // 组装编辑时，开票商品列表数据
    splitDetailEle(info) {
      let selectedDataInfo = {
        invgoodsname: info.invgoodsname,
        invkindinfo: info.invkindinfo,
        num: info.num,
        unit: info.unit,
        availableinv: '', // 商品可使用库存
        unitprice: info.unitprice,
        amount: info.amount,
        taxrate: info.taxrate,
        taxamount: info.taxamount,
        minprice: '', // 最小单价
        maxprice:  '', // 最大单价
        invgoodscode: info.invgoodscode,
        issuppdecimal: '', // 是否支持散开
        totalamount: Number((info.taxamount + info.amount).toFixed(2)), // 价税总和
      };
      return selectedDataInfo;
    },
    // 组装编辑时，打包信息数据
    splitFormEle(info) {
      // 组装开票表单数据
      let totalAmount = info.taxamount + info.amount;
      if(String(totalAmount).indexOf('.')!=-1) {
        totalAmount = Number(totalAmount.toFixed(2));
      }
      let isForm ={
        totalAmount: totalAmount,//本次开票价税总额
        invgoodsname: info.invgoodsname,//产品名称
        invkindinfo: info.invgoodsname,//规格型号
        taxrate: info.taxrate,//产品税率
        taxamount: info.taxamount,//税额总计
        unit: info.unit,//单位
        amount: info.amount,//产品金额
        unitprice: info.unitprice,//产品单价
        num: info.num,
        haveSelectedData: [],//创业发票内容已选择的商品项
        toatalMinAmount: 0, // 最小区间的金额总和
        toatalMaxAmount: 0, // 最大区间的金额总和
        toatalMinPrice: 0, // 最小区间的金额总和
        toatalMaxPrice: 0, // 最大区间的金额总和
      };
      return isForm;
    },
    // 获取开票商品列表信息
    getInvgoodsinfoList(codes,findex,flength) {
      let invParams = {
        invgoodscodes: codes
      }
      api.GET_INVGOODSINFOLIST(invParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            let invoicegoodsList = res.data.data;
            invoicegoodsList.forEach(item => {
              let index = codes.split(',').indexOf(item.invgoodscode);
              if(this.applelyInvoiceForm.type == 1) {
                this.cacheList[findex].toatalMinAmount = this.cacheList[findex].toatalMinAmount + item.num*item.minprice; // 最小区间的金额总和
                this.cacheList[findex].toatalMaxAmount = this.cacheList[findex].toatalMaxAmount + item.num*item.maxprice; // 最大区间的金额总和
                this.cacheList[findex].toatalMinPrice = this.cacheList[findex].toatalMinPrice + item.minprice; // 最小区间的单价总和
                this.cacheList[findex].toatalMaxPrice = this.cacheList[findex].toatalMaxPrice + item.maxprice; // 最大区间的单价总和
                this.cacheList[findex].haveSelectedData[index].availableinv = item.availableinv;
                this.cacheList[findex].haveSelectedData[index].minprice = item.minprice;
                this.cacheList[findex].haveSelectedData[index].maxprice = item.maxprice;
                this.cacheList[findex].haveSelectedData[index].issuppdecimal = item.issuppdecimal;
              } else {
                let availableinv = item.availableinv + this.detailUsedStock[item.invgoodscode];
                if(String(availableinv).indexOf('.')!=-1) {
                  availableinv = Number(availableinv.toFixed(1));
                }
                this.cacheList[findex][index].availableinv = availableinv;
                this.cacheList[findex][index].minprice = item.minprice;
                this.cacheList[findex][index].maxprice = item.maxprice;
                this.cacheList[findex][index].issuppdecimal = item.issuppdecimal;
              }
            })
            if(this.applelyInvoiceForm.type == 1) {
              this.cacheList[findex].toatalMinAmount = this.cacheList[findex].toatalMinAmount.toFixed(2); // 最小区间的金额总和
              this.cacheList[findex].toatalMaxAmount = this.cacheList[findex].toatalMaxAmount.toFixed(2); // 最大区间的金额总和
              this.cacheList[findex].toatalMinPrice = this.cacheList[findex].toatalMinPrice.toFixed(2); // 最小区间的单价总和
              this.cacheList[findex].toatalMaxPrice = this.cacheList[findex].toatalMaxPrice.toFixed(2); // 最大区间的单价总和
            }
            if(findex == (flength-1)) {
              setTimeout(() => {
                this.returnPackStock();
              }, 10);
            }
          }
        }
      })
    },
    // 编辑打包开票时 还原开票商品的库存
    returnPackStock() {
      this.cacheList.forEach(item => {
        item.haveSelectedData.forEach(sitem => {
          let availableinv = sitem.availableinv + this.detailUsedStock[sitem.invgoodscode];
          if(String(availableinv).indexOf('.')!=-1) {
            availableinv = Number(availableinv.toFixed(1));
          }
          sitem.availableinv = availableinv;
        })
      })
    },
    // 重新开票时 调用 ------------------------------------------------------------------------------------- 重新开票时 调用
    // 获取开票详情
    getInvoiceRecordDetail() {
      api.GET_INVOICERECORDDETAIL({recordcode: this.recordCode}).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.recordInfo = res.data.data;
            // 获取购买方/销售方信息
            this.getInvoicetitleDetail(this.recordInfo.salercode,'saler');
            this.getInvoicetitleDetail(this.recordInfo.buyercode,'buyer');
            // 设置开票信息
            this.setInvoiceFrom(this.recordInfo);
            // 调用明细缓存信息
            this.getGoodsCache(this.recordCode)
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.message,
            offset: 200
          })
        }
      })
    },
    // 获取购买方/销售方信息
    getInvoicetitleDetail(code,type) {
      api.GET_INVOICETITLEDETAIL({infocode: code}).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            if(type == 'saler') {
              this.sellerInfo = res.data.data;
              this.getMaxprice()
            } else {
              this.buyerInfo = res.data.data;
            }
          }
        }
      })
    },
    // 设置开票信息
    setInvoiceFrom(info) {
      this.applelyInvoiceForm.type = info.type;
      this.applelyInvoiceForm.invmedium = info.invmedium;
      this.applelyInvoiceForm.applymeno = info.applymeno;
      this.applelyInvoiceForm.email = info.email;
      this.bindMemberInfo.caninvoiceprice = this.bindMemberInfo.caninvoiceprice + info.totalamount;
      this.bindMemberInfo.toinvoiceprice = this.bindMemberInfo.toinvoiceprice - info.totalamount;
      if(info.type == 1) {
        this.alreadyInvoiceMoney = info.totalamount;
      } else {
        this.allTotalMoney = info.totalamount;
        this.totalMoney = info.totalamount;
      }
    },
  },
  created() {
    
  },
  mounted () {
    if(this.$route.query.recordcode) {
      this.recordCode = this.$route.query.recordcode;
    }
    if(sessionStorage.getItem('invoiceMemberCode')&&sessionStorage.getItem('invoiceMemberCode')!=undefined) {
      this.memberCode = sessionStorage.getItem('invoiceMemberCode');
      sessionStorage.setItem('invoiceMemberCode','');
      // 获取会员基本信息
      this.getMemberDetail()
      // 缓存初始化接口
      this.initGoodsCache(this.recordCode)
    } else {
      if(this.$route.params.memberCode) {
        this.memberCode = this.$route.params.memberCode;
        // 获取会员基本信息
        this.getMemberDetail()
        // 缓存初始化接口
        this.initGoodsCache(this.recordCode)
      }
    }

  },
}
</script>

<style scoped>
.mainDet {padding:20px 20px 85px; height: calc(100% - 105px);}
.pdr50 {padding-right:50px;width:auto;}
.el-form>>>.el-input-group__append,
.el-table>>>.el-input-group__append,
.el-form>>>.el-input-group__prepend,
.el-table>>>.el-input-group__prepend {padding:0 10px;}

.commonTit b,.invoiceBox dt {white-space: nowrap;}
.invoiceBox dl{padding-left:40px;min-width: 995px;}
.name150 {display:inline-block;width:auto;max-width:150px;vertical-align: top; margin-right:10px;font-weight: normal;color:#999;}
.invoiceBox dd:nth-child(2){margin-right:20px;}
.invoiceBox dd {color:#999;}
.invoiceBox dd span {cursor: text;}
.invoiceBox dd span:not(.name150) {color:#FA2F2F; font-weight: normal;}
@media screen and (max-width: 1300){
  .commonTit em {display:block;}
}

/*买卖双方 start*/
.tradingRoleBox {margin:20px 0;position:relative;width:80%;}
.tradeWrap .bannerBg {height:165px;}
.tradeWrap.selval {min-width: 520px;}
.tradeWrap:first-child {margin-right:20px;}
.basicWrap li{margin:10px 0;}
.basicWrap li em{color:#999;width:100px;display:inline-block;text-align:right}
.basicWrap li b{color:#333}
.rulrMemo{display: -webkit-flex; display: flex;}
.rulrMemo b{max-width:calc(100% - 100px)}
.bannerBg{background: #fcfcfc;padding: 15px 20px 5px;border-radius:4px; box-shadow: 0 0 8px 1px #ebf0f8;}
.bannerBg .bannerTit{color: #333;}
.bannerBg .bannerTit b{font-weight: bold;}
.bannerBg .el-tag {height: 16px; padding: 0 2px;line-height: 14px; font-size: 12px;font-weight: normal;}
.bannerBg .bannerTit em {float:right;cursor: pointer;}
@media screen and (max-width: 1500px) {
  .tradingRoleBox{width: 100%!important;}
}
/*买卖双方 end*/

.invoiceBox >>> .el-form-item:not(.allWithWrap) .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.invoiceBox >>> .el-form-item__content .el-select,.invoiceBox >>> .el-form-item__content .el-cascader, .invoiceBox >>> .el-form-item__content .el-date-editor {width: 100%;}
.invoiceBox >>> .el-form-item:last-child {margin-bottom:0;}
.btnLine {padding:10px 0; text-align: right;}
.btnLine span {cursor: pointer;}
.btnLine i {padding:0 10px;}

/*选择买卖方弹窗 */
.tradeDlog>>>.el-dialog{width:1250px;}
.tradeDlog >>> .el-table tr {cursor: pointer;}

.radioGroup span { font-size: 14px; padding-right:40px; cursor: pointer;}
.radioGroup span:before {padding-right:5px; color:#ccc;font-size: 18px;vertical-align: top;}
.radioGroup .iconradio:before {color:var(--main-color);}
/*创建发票内容弹窗 start */
.createInvoiceBox>>>.el-dialog{width:80%;min-width:1350px;}
.ftDgTip {position:absolute; left:20px; color:#999; font-size: 12px;}
.ftDgTip em {color:#f56c6c; padding:0 5px; font-size: 16px; font-weight: 600;}
.memberLine {padding-bottom:10px;}
.memberLine span:not(.textFl) {margin-right:20px;}
.createInvoiceBox >>> .el-form-item--small.el-form-item {margin-bottom:10px!important;}
.createInvoiceBox >>> .el-form--inline .el-input {width:auto;}
.createInvoiceBox >>> .el-form .el-input-number {width:100%;}
.editIpt {width:130px;}
.editIpt>>>.el-input__inner {text-align: center;}
.pl10 {padding-left:10px;}

.goodsWrap >>> .el-form-item:not(.allWith) .el-form-item__content {width:65%; min-width: 180px; max-width: 240px;}
.goodsWrap >>> .el-form-item__content .el-select,.goodsWrap >>> .el-form-item__content .el-cascader,.goodsWrap >>> .el-date-editor--daterange.el-input__inner,.goodsWrap >>> .el-form-item__content .el-date-editor {width: 100%;}
.goodsWrap {width:100%;  -webkit-display: flex;display: flex;}
.defineRow {position: relative;}
.defineRow .btnRight {position: absolute;z-index:1; top:0; left:calc(100% + 10px); display:inline-block;white-space: nowrap;}
.btnRight.blueColor {cursor: pointer;}
.txtItem {margin-left:-50px;}
@media screen and (max-width: 1800px){
  .txtItem {margin-left:0;}
}
.txtItem >>> .el-form-item .el-form-item__content {margin-left:0!important;}
/*创建发票内容弹窗 end */
.unitTxt{margin-left: 5px;max-width: 50px;}
.avaiTxt{max-width:130px ;}
.unitTxt,.avaiTxt{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}

</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/InvoiceManage/InvoiceApply.vue